import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getDescuentosPanel = async (searchTerm, page, perPage) => {
  let queryParams = [];

  if (searchTerm) {
    queryParams.push(`desc_descripcion=${encodeURIComponent(searchTerm || '')}`);
  }
  if (page) {
    queryParams.push(`page=${encodeURIComponent(page)}`);
  }
  if (perPage) {
    queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
  }
  const queryString = queryParams.length > 0 ? `?}&${queryParams.join('&')}` : '';

  return await getData("/descuentos", queryString);
};


export const getDescuentoById = async (id) => {
    const res = await getData(`/descuentos/${id}`)
    return res
}

export const postDescuento = async (body) => {
    const res = await postData('/descuentos', body)
    return res
}

export const patchDescuento = async (id, body) => {
    const res = await patchData(`/descuentos/${id}`, body)
    return res
}

export const deleteDescuento = async (id) => {
    const res = await deleteData(`/descuentos/${id}`)
    return res
}